import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;
export const Details = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  gap: 4px;
`;
export const Type = styled.div `
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  color: ${Colors.GS600};
`;
export const Supporter = styled.div `
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
export const Calculations = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;
export const Profit = styled.div `
  font-size: 14px;
`;
export const Date = styled.div `
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: ${Colors.GS600};
  display: flex;
  gap: 2px;
`;
export const RedeemsLeft = styled.div `
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: ${Colors.GS600};
`;
